export default __webpack_public_path__ + "static/media/seb.28ba1ef4.svg";